export default __webpack_public_path__ + "static/media/pause.751c6e38.svg";